<template>

<b-card class="col-3">
  <div class="d-flex justify-content-between align-items-center">
    <h5 class="mb-1">Observaciones:</h5>
    <b-button 
      v-b-toggle.observaciones-collapse 
      variant="link" 
      class="p-0"

    >
    <b-icon 
        :icon="isCollapsed ? 'eye' : 'eye-slash'" 
        shift-v="+1"
      />
    </b-button>
  </div>

  <b-collapse id="observaciones-collapse" @show="isCollapsed = false" @hide="isCollapsed = true">
    <div
      v-if="totalSinDiagnosticos > 0"
      class="row mb-2"
    >
      <h4 class="col-9">Sin diagnosticos: {{ totalSinDiagnosticos }}</h4>
      <b-form-checkbox
        v-model="observacionSelected"
        :value="'sinDiagnosticos'"
        switch 
        size="md" 
        class="col"
        :disabled="isLoading"
      />
    </div>

    <div 
      v-if="nSinPrincipal > 0"
      class="row mb-2"
    >
      <h4 class="col-9">Diag. sin principal: {{ nSinPrincipal }}</h4>
      <b-form-checkbox
        v-model="observacionSelected"
        :value="'sinPrincipal'"
        switch 
        size="md" 
        class="col"
        :disabled="isLoading"
      />
    </div>

    <div 
      v-if="nSinFirmas > 0"
      class="row mb-2"
    >
      <h4 class="col-9">Sin firma: {{ nSinFirmas }}</h4>
      <b-form-checkbox
        v-model="observacionSelected"
        :value="'sinFirmas'"
        switch 
        size="md" 
        class="col"
        :disabled="isLoading"
      />
    </div>

    <div
      v-if="nSinAs400 > 0"
      class="row mb-2"
    >
      <h4 class="col-9">Sin As400: {{ nSinAs400 }}</h4>
      <b-form-checkbox
        v-model="observacionSelected"
        :value="'sinAs400'"
        switch 
        size="md" 
        class="col"
        :disabled="isLoading"
      />
    </div>

    <div
      v-if="sinJustificacionLabs && sinJustificacionLabs > 0"
      class="row mb-2"
    >
      <h4 class="col-9">Labs sin justificacion: {{ sinJustificacionLabs }}</h4>
      <b-form-checkbox
        v-model="observacionSelected"
        :value="'sinJustifyLabs'"
        switch 
        size="md" 
        class="col"
        :disabled="isLoading"
      />
    </div>

    <div
      v-if="sinJustifyImagenes && sinJustifyImagenes > 0"
      class="row mb-2"
    >
      <h4 class="col-9">Imagenes sin justificacion: {{ sinJustifyImagenes }}</h4>
      <b-form-checkbox
        v-model="observacionSelected"
        :value="'sinJustifyImagenes'"
        switch 
        size="md" 
        class="col"
        :disabled="isLoading"
      />
    </div>
  </b-collapse>
</b-card>

</template>

<script>
import { getEstablecimientoLS, comprobarRoles } from '@/shared/helpers';
import rutas from '@/assets/utils/rutas.json';
import axios from 'axios';
import { getIdDoctorLS } from '@/shared/helpers/dataLocalStorage';
import { ROLES } from '@/shared/constants';
import { mapState } from 'vuex';

export default {

  name: "FilterObservaciones",

  created() {
    this.getObservaciones();
  },

  data() {
    return {
      isCollapsed: true,
      observacionSelected:null,
      filterAtenciones: null,

      totalSinDiagnosticos:null,
      nSinPrincipal: null,
      nSinFirmas: null,
      nSinAs400: null,
      sinJustificacionLabs: null,
      sinJustifyImagenes:null,

      isLoading:false
    }
  },


  methods: {
    async getObservaciones() {
      const query = `
        query ObservacionesAtenciones(
          $establecimientoId: ID
          $doctor:ID
          $paciente: ID
          $tipoCobertura:ID
          $fechaDesde: String
          $fechaHasta: String
          $busqueda: String
          $estadoRevision: ID
          $especialidad: ID
          $porRevisar: String
        ) {
          observacionesAtenciones(
            doctor: $doctor, 
            establecimientoId: $establecimientoId
            paciente: $paciente
            tipoCobertura: $tipoCobertura
            fechaDesde: $fechaDesde
            fechaHasta: $fechaHasta
            estadoRevision: $estadoRevision
            especialidad: $especialidad
            busqueda: $busqueda
            porRevisar: $porRevisar
          ) {
            status
            sinDiagnosticos
            sinPrincipal
            sinFirmas
            sinAs400
            sinJustificacionLabs
            sinJustifyImagenes
          }
        }
      `;

      const establecimiento = getEstablecimientoLS();
      let doctor = null;
      if(this.isDoctor) doctor = getIdDoctorLS();

      const variables = {
        establecimientoId: establecimiento.id,
        doctor: doctor,
        tipoCobertura: this.filterAtenciones?.cobertura,
        especialidad: this.filterAtenciones?.especialidad,
        estadoRevision: this.filterAtenciones?.estadoRevision,
        fechaDesde: this.filterAtenciones?.fechaDesde,
        fechaHasta: this.filterAtenciones?.fechaHasta,
        paciente: this.filterAtenciones?.paciente?.value,
        porRevisar: this.filterAtenciones?.porRevisar

      }

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });

        if(response.status !== 200) return;

        const response2 = response.data.data.observacionesAtenciones;

        this.totalSinDiagnosticos = response2 ? response2.sinDiagnosticos : '';
        this.nSinPrincipal        = response2 ? response2.sinPrincipal : '';
        this.nSinFirmas           = response2 ? response2.sinFirmas : '';
        this.nSinAs400            = response2 ? response2.sinAs400 : '';
        this.sinJustificacionLabs = response2 ? response2.sinJustificacionLabs: '';
        this.sinJustifyImagenes   = response2 ? response2.sinJustifyImagenes: '';

      } catch (error) {
        console.log(error)
      }
    },
  },


  computed:{

    isDoctor(){
      return comprobarRoles( ROLES.DOCTOR );
    },

    ...mapState({
      stFilterAtencionesObservaciones  : state => state.generals.filterAtenciones.observaciones,
      stFilterAtenciones : state => state.generals.filterAtenciones
    }),
  },


  watch: {

    stFilterAtenciones: {
      deep: true,
      handler(newValue) {
        console.log("este es el nuevo valor", newValue)
        this.filterAtenciones = newValue;
        this.getObservaciones();
      }
    },
    stFilterAtencionesObservaciones: {
      deep: true,
      handler(newValue) {
        this.observacionSelected = newValue;
      }
    },

    observacionSelected: {
      deep: true,
      handler(newValue) {
        this.$store.commit("setFilterAtencionesObservaciones", newValue);
        // localStorage.setItem('filterAtenciones', JSON.stringify(newValueFilters));
      }
    }
  }
}
</script>